import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { TopMenuButton } from '../button';
import BuglyHelper from './icons/bugly-helper.react.svg?react';

export const Helper = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  let wxUrl = 'wxwork://message?uin=8444251803319680';
  let btnText = t('Bugly小助手');
  if (pathname.startsWith('/compliance')) {
    wxUrl = 'wxwork://message?uin=8444251012323332';
    btnText = t('Rightly小助手');
  }
  const onClick = () => window.open(wxUrl, '_self', 'noreferrer');
  return   <TopMenuButton  onClick={onClick} >
    <BuglyHelper/>
    <span>{btnText}</span>
  </TopMenuButton>;
};
